import React from "react";

import AcademicDetails from "../Items/AcademicDetails";

const academicData = [
  {
    id: 1,
    year: "2022 - 2024",
    degree: "Master's of Computer Application",
    college: "Chandigarh University",
    link: "https://www.cuchd.in/",
    content: "MCA in Computer Science and Application.",
  },
  {
    id: 2,
    year: "2019 - 2022",
    degree: "Bachelor’s of Computer Application",
    college: "Al-Falah University",
    link: "https://alfalahuniversity.edu.in/index.php",
    content: "BCA in Computer Application and Software Development.",
  },
  {
    id: 3,
    year: "2016 - 2018",
    degree: "Senior School (Class XII) Examination, PCB",
    college: "Darshan Sah College (BSEB)",
    link: "https://www.dscollegekatihar.ac.in/",
    content: "Higher Secondary Examination (PCB) under BSEB.",
  },
  {
    id: 4,
    year: "2014 - 2016",
    degree: "Secondary School (Class X) Examination",
    college: "Govt High School Katihar (BSEB)",
    link: "https://schools.org.in/katihar/10100103505/govt-high-school-katihar.html",
    content: "Secondary School Matriculation Examination under BSEB.",
  },
];

function AcademicDetailss() {
  return (
    <div className="timeline">
      {academicData.map((experience) => (
        <AcademicDetails experience={experience} key={experience.id} />
      ))}
      <span className="timeline-line"></span>
    </div>
  );
}

export default AcademicDetailss;
